<!--<mat-form-field>
  <input matInput [ngxMatDatetimePicker]="picker" placeholder="Choose a date"
         [min]="minDate" [max]="maxDate" [disabled]="disabled" [(ngModel)]="date" (ngModelChange)="modelChanged($event)">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <ngx-mat-datetime-picker #picker [showSpinners]="showSpinners" [showSeconds]="showSeconds"
                           [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond" [touchUi]="touchUi"
                           [color]="color" [enableMeridian]="enableMeridian">
  </ngx-mat-datetime-picker>
</mat-form-field>-->

<div class="eveDatePicker">
  <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [min]="min">
    <input readonly matStartDate formControlName="start" placeholder="Start date" [(ngModel)]="startDate" (ngModelChange)="modelChanged($event)">
    <input readonly matEndDate formControlName="end" placeholder="End date" [(ngModel)]="endDate" (ngModelChange)="modelChanged($event)">
  </mat-date-range-input>
</div>
<div class="eveDatePickerButton">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker></mat-date-range-picker>
</div>
